import { useEffect, useRef, useState } from 'react'
import { shouldLoadSlideImage } from './lazyImages'

/** True once this slide is visible or is the single slide after the visible ones. Stays true so the image is not unloaded. */
export function useSlideImageActive() {
  const ref = useRef(null)
  const [active, setActive] = useState(false)

  useEffect(() => {
    if (active) {
      return undefined
    }

    const slide = ref.current?.closest('.swiper-slide')
    const wrapper = slide?.parentElement
    if (!slide || !wrapper) {
      return undefined
    }

    const markActive = () => {
      if (shouldLoadSlideImage(slide)) {
        setActive(true)
      }
    }

    markActive()

    const observer = new MutationObserver(markActive)
    observer.observe(wrapper, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    })

    return () => observer.disconnect()
  }, [active])

  return { ref, active }
}
